import { Field, FormikErrors, FormikTouched } from 'formik';
import './FormField.scss';
import { useTranslation } from '../../context/translationContext';
interface Props {
  id: string | number;
  name: string;
  label?: string;
  className?: string;
  errors?: FormikErrors<any>;
  touched?: FormikTouched<any>;
  type?: string;
  multiline?: boolean;
  rows?: number;
  component?: string;
  helperText?: JSX.Element;
  checked?: boolean;
  children?: JSX.Element[] | JSX.Element;
  onChange?: (e?: any) => void;
  showEmptyOption?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onFocus?: (e?: any) => void;
  onBlur?: () => void;
  value?: any;
}

/**
 * Basic field komponenta
 */
export default function FormField({
  id,
  name,
  label,
  className,
  errors,
  touched,
  type,
  multiline,
  rows,
  component,
  helperText,
  checked,
  children,
  onChange,
  showEmptyOption,
  readOnly,
  disabled,
  onFocus,
  onBlur,
  value,
}: Props) {
  const { t } = useTranslation();
  if (type === 'select')
    return (
      <>
        <div className="relative">
          {label && (
            <label
              htmlFor={name}
              className={`absolute text-sm text-gray-500 text-gray-400 duration-200 transform -translate-y-5 scale-85 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-300 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-85 peer-focus:-translate-y-5 left-1`}
            >
              {label}
            </label>
          )}
          <Field
            id={id}
            as="select"
            name={name}
            readOnly={readOnly}
            disabled={disabled}
            className={`border border-gray-600 text-gray-900 text-sm rounded-lg focus:border-gray-500 block w-full p-2.5 focus:border-gray-600 ${className}`}
          >
            {showEmptyOption && (
              <option key={-1} value={''}>
                {t('general.select')}
              </option>
            )}
            {children}
          </Field>
        </div>

        {helperText && (
          <p id={id as string} className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            {helperText}
          </p>
        )}
        {errors && touched && errors[name] && touched[name] && (
          <div className="relative mt-1 ml-2 text-red-500 text-sm">{errors[name]?.toString()}</div>
        )}
      </>
    );
  return (
    <>
      <div className="relative">
        {onChange && (
          <Field
            id={id}
            name={name}
            type={type}
            placeholder={' '}
            className={
              type === 'checkbox'
                ? `${className}`
                : `block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 rounded-md appearance-none border border-gray-600 focus:border-gray-900 focus:outline-none focus:ring-0 focus:border-gray-600 peer ${className}`
            }
            multiline={'true'}
            rows={rows ? rows : undefined}
            component={component}
            checked={checked}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            value={value}
            readOnly={readOnly}
            disabled={disabled}
            autoComplete="off"
          />
        )}
        {!onChange && (
          <Field
            id={id}
            name={name}
            type={type}
            placeholder=" "
            className={
              type === 'checkbox'
                ? `${className}`
                : `block px-2.5 pb-2 pt-2 w-full text-sm text-gray-900 rounded-md appearance-none border border-gray-600 focus:border-gray-900 focus:outline-none focus:ring-0 focus:border-gray-600 peer ${className}`
            }
            multiline={5}
            rows={rows ? rows : undefined}
            component={component}
            checked={checked}
            readOnly={readOnly}
            disabled={disabled}
            autoComplete="off"
          />
        )}
        {label && (
          <label
            htmlFor={name}
            className={`absolute text-sm text-gray-500 text-gray-400 duration-200 transform -translate-y-5 scale-85 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-300 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 ${
              multiline ? `peer-placeholder-shown:top-1/4` : `peer-placeholder-shown:top-1/2`
            } peer-focus:top-2 peer-focus:scale-85 peer-focus:-translate-y-5 left-1`}
          >
            {label}
          </label>
        )}
      </div>
      {helperText && (
        <p id={id as string} className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          {helperText}
        </p>
      )}
      {errors && touched && errors[name] && touched[name] && (
        <div className="relative mt-1 ml-2 text-red-500 text-sm">{errors[name]?.toString()}</div>
      )}
    </>
  );
}
